import { request } from '../utils/httpClient';

export const getTLCList = (data) => {
  let url = `/resources/tlc?page_size=${data.rowsPerPage}&page=${data.page}`;
  if (data.search) {
    url += `&search=${data.search}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  if (data.spd) {
    url += `&spd=${data.spd}`;
  }
  return request({
    url: url,
    method: 'GET',
  });
};

export const getTLCDetail = (data) => {
  return request({
    url: `/resources/tlc/${data.id}`,
    method: 'GET',
  });
};

export const getBnBList = (data) => {
  let url = `/resources/bnb?page_size=${data.rowsPerPage}&page=${data.page}`;
  if (data.search) {
    url += `&search=${data.search}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  if (data.chapter) {
    url += `&chapter=${data.chapter}`;
  }
  if (data.spdChapter) {
    url += `&spd=${data.spdChapter}`;
  }
  return request({
    url: url,
    method: 'GET',
  });
};

export const getBnBDetail = (data) => {
  return request({
    url: `/resources/bnb/${data.id}`,
    method: 'GET',
  });
};

export const getMessageList = (data) => {
  let url = `/messages/list?page_size=${data.rowsPerPage}&page=${data.page}`;
  if (data.search) {
    url += `&search=${data.search}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  if (data.status && data.status !== 'all') {
    url += `&status=${data.status}`;
  }
  return request({
    url: url,
    method: 'GET',
  });
};

export const getMessageDetail = (data) => {
  return request({
    url: `/messages/${data.id}`,
    method: 'GET',
  });
};

export const getMessageStatus = () => {
  return request({
    url: `/messages/status`,
    method: 'GET',
  });
};

export const createMessage = (data) => {
  return request({
    url: `/messages/create`,
    method: 'POST',
    data: data,
  });
};

export const updateMessage = (data) => {
  return request({
    url: `/messages/${data.id}`,
    method: 'PATCH',
    data: data,
  });
};

export const getLocalChapterResources = (data) => {
  return request({
    url: `/resources/local_chapter/${data.chapterId}`,
    method: 'GET',
  });
};

export const getSPDResources = (data) => {
  return request({
    url: `/resources/spd_chapter/${data.chapterId}`,
    method: 'GET',
  });
};

export const patchTLC = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/tlc/${formId}`,
    method: 'PATCH',
    data: data,
  });
};

export const patchTLCMember = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/tlc/${formId}/members/${data.id}`,
    method: 'PATCH',
    data: data,
  });
};

export const postTLCMember = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/tlc/${formId}/members`,
    method: 'POST',
    data: data,
  });
};

export const deleteTLCMember = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/tlc/${formId}/members/${data.id}`,
    method: 'DELETE',
  });
};

export const replaceTLCMember = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/tlc/${formId}/members/${data.id}/replace`,
    method: 'POST',
    data: data,
  });
};
